var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileAiPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 335,
  height: 1334,
  viewBox: "0 0 335 1334",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5246_146030)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 335,
  y1: 0.500977,
  x2: -4.37114e-8,
  y2: 0.500947,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 16.001,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 59.001,
  width: 335,
  height: 223,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 294.001,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 324.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 411.001,
  width: 335,
  height: 60,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 483.001,
  width: 150,
  height: 16,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 519.501,
  x2: -4.37114e-8,
  y2: 519.501,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 539.001,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 565.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 652.001,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 686.501,
  x2: -4.37114e-8,
  y2: 686.501,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 706.001,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 732.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 819.001,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 853.501,
  x2: -4.37114e-8,
  y2: 853.501,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 873.001,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 899.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 986.001,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 1020.5,
  x2: -4.37114e-8,
  y2: 1020.5,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1040,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1066,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1153,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 1187.5,
  x2: -4.37114e-8,
  y2: 1187.5,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1207,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1233,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1320,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5246_146030"
}, /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 1334,
  fill: "white",
  transform: "translate(0 0.000976562)"
})))));
export default SvgMobileAiPlaceholder;